exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".datatable-search-box[data-v-2e371da6]{width:250px}.datatable-search-box input[type=search][data-v-2e371da6]{height:32px}.row-limit-select[data-v-2e371da6]{height:24px;line-height:24px;width:50px;display:inline-block;padding:0}", ""]);

// exports
